import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// What the three features of the booking domain share (50-api/booking.md): the root of their cache keys, so a write
// on one reloads what the others count from it, and the values their forms offer.

export type BookingOptions = InferResponseType<typeof api.booking.options.$get, 200>;

const keys = { all: ["booking"] as const };

export const bookingQueries = {
  ...keys,

  /** Seasons, categories, showrooms and brands of the forms (ADR-048): they change rarely. */
  options: () =>
    queryOptions({
      queryKey: [...keys.all, "options"],
      queryFn: ({ signal }) => unwrap(api.booking.options.$get({}, { init: { signal } })),
      staleTime: 10 * 60_000,
    }),
};
